import React from 'react';
import PropTypes from 'prop-types';
import Badge from 'components/v2/Badge';
import LocationSearch from 'components/site/location-search';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
export default function OriginDsestinationSearch({ filterGroup, filterMetadata, onFilterChange, }) {
    var _a, _b;
    const { t } = useTranslation();
    function renderSelected(label, filterGroup) {
        return (React.createElement("div", { key: label, className: "mb-2" },
            React.createElement(Badge, { color: "green", withRemove: true, onRemove: () => onFilterChange(filterGroup, { address: '' }, false) }, label)));
    }
    const { key } = filterGroup;
    return ((_a = filterMetadata[key]) === null || _a === void 0 ? void 0 : _a.address) ? (renderSelected((_b = filterMetadata[key]) === null || _b === void 0 ? void 0 : _b.address, filterGroup)) : (React.createElement(LocationSearch, { placeholder: titleize(t(filterGroup.name.toUpperCase())), handleLocationSearch: (item) => {
            onFilterChange(filterGroup, item, true);
        } }));
}
OriginDsestinationSearch.propTypes = {
    filterMetadata: PropTypes.object,
    filterGroup: PropTypes.object,
    onFilterChange: PropTypes.func,
};
OriginDsestinationSearch.defaultProps = {
    filterMetadata: {},
    filterGroup: {},
    onFilterChange: () => { },
};
